var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 28.0022H10.56C6.94 28.0022 4 25.0622 4 21.4422V11.9422C4 11.4222 4.42 11.0022 4.94 11.0022H27.06C27.58 11.0022 28 11.4222 28 11.9422V21.4422C28 25.0622 25.06 28.0022 21.44 28.0022Z",
    fill: "url(#paint0_linear_713_8088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 28.0022H10.56C6.94 28.0022 4 25.0622 4 21.4422V11.9422C4 11.4222 4.42 11.0022 4.94 11.0022H27.06C27.58 11.0022 28 11.4222 28 11.9422V21.4422C28 25.0622 25.06 28.0022 21.44 28.0022Z",
    fill: "url(#paint1_linear_713_8088)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 28.0022H10.56C6.94 28.0022 4 25.0622 4 21.4422V11.9422C4 11.4222 4.42 11.0022 4.94 11.0022H27.06C27.58 11.0022 28 11.4222 28 11.9422V21.4422C28 25.0622 25.06 28.0022 21.44 28.0022Z",
    fill: "url(#paint2_linear_713_8088)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 28.0022H10.56C6.94 28.0022 4 25.0622 4 21.4422V11.9422C4 11.4222 4.42 11.0022 4.94 11.0022H27.06C27.58 11.0022 28 11.4222 28 11.9422V21.4422C28 25.0622 25.06 28.0022 21.44 28.0022Z",
    fill: "url(#paint3_radial_713_8088)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 28.0022H10.56C6.94 28.0022 4 25.0622 4 21.4422V11.9422C4 11.4222 4.42 11.0022 4.94 11.0022H27.06C27.58 11.0022 28 11.4222 28 11.9422V21.4422C28 25.0622 25.06 28.0022 21.44 28.0022Z",
    fill: "url(#paint4_radial_713_8088)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28.0022H3C2.45 28.0022 2 28.4522 2 29.0022C2 29.5522 2.45 30.0022 3 30.0022H29C29.55 30.0022 30 29.5522 30 29.0022C30 28.4522 29.55 28.0022 29 28.0022Z",
    fill: "url(#paint5_linear_713_8088)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28.0022H3C2.45 28.0022 2 28.4522 2 29.0022C2 29.5522 2.45 30.0022 3 30.0022H29C29.55 30.0022 30 29.5522 30 29.0022C30 28.4522 29.55 28.0022 29 28.0022Z",
    fill: "url(#paint6_linear_713_8088)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28.0022H3C2.45 28.0022 2 28.4522 2 29.0022C2 29.5522 2.45 30.0022 3 30.0022H29C29.55 30.0022 30 29.5522 30 29.0022C30 28.4522 29.55 28.0022 29 28.0022Z",
    fill: "url(#paint7_radial_713_8088)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28.0022H3C2.45 28.0022 2 28.4522 2 29.0022C2 29.5522 2.45 30.0022 3 30.0022H29C29.55 30.0022 30 29.5522 30 29.0022C30 28.4522 29.55 28.0022 29 28.0022Z",
    fill: "url(#paint8_radial_713_8088)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 9.24217C16.46 9.42217 16.26 9.55217 16.11 9.46217C15.53 9.12217 14.5 8.28217 14.5 6.65217C14.5 5.23217 16.19 4.13217 16.46 2.18217C16.49 1.99217 16.74 1.93217 16.85 2.09217C17.22 2.64217 17.7 3.66217 17.38 4.99217C16.93 6.92217 16.05 6.68217 16.43 9.24217Z",
    fill: "url(#paint9_linear_713_8088)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 9.24217C10.96 9.42217 10.76 9.55217 10.61 9.46217C10.03 9.12217 9 8.28217 9 6.65217C9 5.23217 10.69 4.13217 10.96 2.18217C10.99 1.99217 11.24 1.93217 11.35 2.09217C11.72 2.64217 12.2 3.66217 11.88 4.99217C11.43 6.92217 10.55 6.68217 10.93 9.24217Z",
    fill: "url(#paint10_linear_713_8088)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_713_8088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2576 9.13283C16.2721 9.31283 16.1289 9.33219 16.0566 9.24219C15.7773 8.90219 14.916 8.12997 14.916 6.49997C14.916 5.07997 16.6113 4.59751 16.6113 2.40628C16.6258 2.21628 16.7935 2.24182 16.8695 2.40635C17.1038 2.91406 17.2811 3.27155 17.127 4.60155C16.9102 6.53155 15.7988 6.59375 16.2576 9.13283Z",
    fill: "url(#paint11_linear_713_8088)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_713_8088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2138 9.28125C16.2422 9.63566 15.3153 8.24998 15.4559 6.98436C15.5966 5.71873 16.4683 5.46875 16.6825 2.21094C17.0966 2.96094 17.236 3.70246 17.1669 4.63281C17.0977 5.56317 15.6534 6.77342 16.2138 9.28125Z",
    fill: "url(#paint12_radial_713_8088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2138 9.28125C16.2422 9.63566 15.3153 8.24998 15.4559 6.98436C15.5966 5.71873 16.4683 5.46875 16.6825 2.21094C17.0966 2.96094 17.236 3.70246 17.1669 4.63281C17.0977 5.56317 15.6534 6.77342 16.2138 9.28125Z",
    fill: "url(#paint13_radial_713_8088)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.93 9.24217C21.96 9.42217 21.76 9.55217 21.61 9.46217C21.03 9.12217 20 8.28217 20 6.65217C20 5.23217 21.69 4.13217 21.96 2.18217C21.99 1.99217 22.24 1.93217 22.35 2.09217C22.72 2.64217 23.2 3.66217 22.88 4.99217C22.43 6.92217 21.55 6.68217 21.93 9.24217Z",
    fill: "url(#paint14_linear_713_8088)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_713_8088",
    x: 14.416,
    y: 1.77319,
    width: 3.26953,
    height: 8.02148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_713_8088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_713_8088",
    x: 15.1914,
    y: 1.96094,
    width: 2.24219,
    height: 7.62671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_713_8088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_8088",
    x1: 3.5,
    y1: 19.5022,
    x2: 28.3125,
    y2: 19.5022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18136,
    stopColor: "#ADA0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455919,
    stopColor: "#DBCEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687657,
    stopColor: "#F9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871536,
    stopColor: "#FAF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994962,
    stopColor: "#ECEAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_713_8088",
    x1: 16,
    y1: 21.9375,
    x2: 16,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153285,
    stopColor: "#D0BEE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627737,
    stopColor: "#7C7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70073,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_713_8088",
    x1: 16,
    y1: 11.0022,
    x2: 16,
    y2: 28.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0136575,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.3125 11.0022) rotate(91.9797) scale(0.904592 4.81537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99989E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.375 11.7812) rotate(90) scale(0.484375 13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_713_8088",
    x1: 2,
    y1: 30.0022,
    x2: 30,
    y2: 30.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#634340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388393,
    stopColor: "#724842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_713_8088",
    x1: 16,
    y1: 28.0022,
    x2: 16,
    y2: 30.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.436401,
    stopColor: "#7B4359",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873901,
    stopColor: "#7B4568"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6875 28.625) rotate(90) scale(0.625 10.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7A76",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.625 29.5) rotate(90) scale(1.1875 8.4906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F5977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72575A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_713_8088",
    x1: 17.3125,
    y1: 6.03125,
    x2: 14.8125,
    y2: 5.74573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.110003,
    stopColor: "#C0C1C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652938,
    stopColor: "#8E8D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_713_8088",
    x1: 11.8125,
    y1: 6.03125,
    x2: 9.3125,
    y2: 5.74573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.110003,
    stopColor: "#B3B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524238,
    stopColor: "#8E8D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_713_8088",
    x1: 16.7754,
    y1: 6.35937,
    x2: 14.916,
    y2: 6.03125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBBC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A98A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7997 2.59375) rotate(90) scale(3.75 3.08036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_713_8088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6747 10.2188) rotate(-75.7956) scale(4.58469 3.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_713_8088",
    x1: 22.8125,
    y1: 6.03125,
    x2: 20.3125,
    y2: 5.74573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.110003,
    stopColor: "#C4C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8D90"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacup);
export default __webpack_public_path__ + "static/media/Teacup.7d9f12d48b51242bef6dc4d56ea70a07.svg";
export { ForwardRef as ReactComponent };